import { createResponsiveSlider } from '../utils/responsive-slider';

// Product grid on desktop, slider with a progress bar below 1024px.
// Keep in sync with the media queries for .single-product-collection in
// _blog.scss.
const SLIDER_QUERY = '(max-width: 1023px)';

const initProductCollection = (section) => {
  if (section.dataset.productCollectionReady === 'true') return;

  const root = section.querySelector('.single-product-collection__viewport');
  const track = section.querySelector('.single-product-collection__track');
  const list = section.querySelector('.single-product-collection__grid');
  const slides = Array.from(
    section.querySelectorAll('.single-product-collection__slide')
  );

  if (!root || !track || !list || !slides.length) return;

  const slider = createResponsiveSlider({
    section,
    root,
    track,
    list,
    slides,
    query: SLIDER_QUERY,
    progress: section.querySelector('.single-product-collection__progress'),
    progressBar: section.querySelector('[data-collection-progress]'),
    progressThumb: section.querySelector('[data-collection-thumb]'),
    options: {
      gap: 'clamp(12px, 2.34vw, 24px)',
      // Cards start at the container edge; the next one peeks in on the right.
      padding: { left: 'var(--container-padding)', right: 0 },
    },
    getSlideLabel: (slide) =>
      slide?.querySelector('.product-card__title')?.textContent.trim(),
  });

  let frame = null;
  const requestSync = () => {
    if (frame !== null) return;

    frame = window.requestAnimationFrame(() => {
      frame = null;
      slider.sync();
      document.dispatchEvent(new Event('holytaste:wishlist-sync'));
    });
  };

  if ('ResizeObserver' in window) {
    new ResizeObserver(requestSync).observe(section);
  } else {
    window.addEventListener('resize', requestSync);
  }

  requestSync();
  section.dataset.productCollectionReady = 'true';
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-product-collection]')
    .forEach(initProductCollection);
});
